import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BlankPageOption = ({ onSelect }) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 border-2 border-dashed border-primary/30 rounded-xl p-6 md:p-8 lg:p-10 text-center hover:border-primary/50 transition-all duration-300">
      <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-4 md:mb-6 rounded-2xl bg-primary/10 flex items-center justify-center">
        <Icon name="Plus" size={32} color="var(--color-primary)" />
      </div>

      <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
        Начать с пустой страницы
      </h3>

      <p className="text-sm md:text-base text-text-secondary mb-6 max-w-md mx-auto">
        Создайте уникальный дизайн с нуля, используя наш интуитивный конструктор страниц с функцией перетаскивания элементов
      </p>

      <div className="flex flex-wrap items-center justify-center gap-3 mb-6">
        <span className="caption bg-background text-text-secondary px-3 py-1.5 rounded-full flex items-center gap-1">
          <Icon name="Layout" size={14} />
          Полная свобода дизайна
        </span>
        <span className="caption bg-background text-text-secondary px-3 py-1.5 rounded-full flex items-center gap-1">
          <Icon name="Palette" size={14} />
          Настройка стилей
        </span>
        <span className="caption bg-background text-text-secondary px-3 py-1.5 rounded-full flex items-center gap-1">
          <Icon name="Zap" size={14} />
          Быстрый старт
        </span>
      </div>

      <Button
        variant="default"
        size="lg"
        iconName="ArrowRight"
        iconPosition="right"
        onClick={onSelect}
      >
        Создать пустую страницу
      </Button>
    </div>
  );
};

export default BlankPageOption;